export default "__VITE_ASSET__CX_4IfqV__"